"use client";
import { UserFilled } from "../../assets/Icons";
import { getAvatar } from "../../utils/avatar";

type Size = "large" | "small" | "extraSmall" | "md" | "xs";

type IAvatar = {
  name?: string;
  size?: Size;
  className?: string;
};

const getStyleBySize = (sz: Size) =>
  ({
    large:
      "h-[5rem] w-[5rem] min-w-[5rem] leading-tight font-medium text-[2rem] leading-[1.2]",
    small: "h-10 w-10 min-w-[2.5rem]",
    md: "h-[60px] w-[60px] text-[24px] font-medium",
    extraSmall: "h-8 w-8 min-w-[2rem] text-sm font-medium",
    xs: "h-7 w-7 font-medium ",
  }[sz]);

/**
 *
 * Component to render user avatar
 * @param {IAvatar} { text, size = 'large', className }
 * @return {*}
 */
const Avatar = ({ name, size = "large", className }: IAvatar) => {
  return (
    <div
      className={`${getStyleBySize(
        size
      )} ${className}  font-normal inline-flex items-center justify-center rounded-full bg-[linear-gradient(180deg,_#D1D1D1_0%,_#999_100%)] text-white`}
    >
      {name?.length ? (
        getAvatar(name)
      ) : (
        <span
          className={`${size == "large" ? "mt-2 h-20 w-20" : "mt-1 h-9 w-9"}`}
        >
          {/* @ts-ignore */}
          <UserFilled className={`${size == "xs" ? "p-[4px] pt-[6px]" : ""}`} />
        </span>
      )}
    </div>
  );
};

export default Avatar;
